// extracted by mini-css-extract-plugin
export var fromRefinerFlyoutContainer = "KcuCp";
export var fromRefinerSearchInput = "vV88J";
export var fromRefinerSearchRow = "JW2vK";
export var fromRefinerSelectedPeople = "W5ctP";
export var fromRefinerSelectedPill = "fin81";
export var fromRefinerSelectedPillText = "o3MWR";
export var fromRefinerSuggestionList = "EZ4K3";
export var fromRefinerSuggestionOption = "FWgcc";
export var fromRefinerSuggestionOptionActive = "lT3O1";
export var fromRefinerSuggestionStatus = "uAbYH";
export var fromRefinerToggledButton = "KmMw3";